import TazApiService from '@/services/tazapi/tazApi.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {

    // -------------------HMTerrAssign data search
    async searchRepsForWebQuote ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.searchRepsForWebQuote(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // -------------------end HMTerrAssign data search

    // -------------------Territory data search
    async getAllTerritories ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.getAllTerritories(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // -------------------end Territory data search

     // ------------------- TAZ Marker data search

    async getFacilitiesForMap ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.getFacilitiesForMap(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    // -------------------end  TAZ Marker data search

    // ------------------- TAZ Customer/Facility data search
    async getRepListByZipCodeReport ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.getRepListByZipCodeReport(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // -------------------end  TAZ Customer/Facility data search

    // ----------------- Table MapSavedMap
    async loadSavedMap({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.loadSavedMap(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    async getSavedMaps({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.getSavedMaps(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    async saveSavedMap({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            console.log(payload)
            const response = await TazApiService.saveSavedMap(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    // ----------------- End Table MapSavedMap

    // ------------------- GeoJson data retrieve
    async getTerrZipGeoJson ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TazApiService.getTerrZipGeoJson(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // -------------------end  GeoJson data retrieve

}

const mutations = {
}

export const tazApi = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}